import gql from "graphql-tag";

export const MY_HR_GET_FILTERED_LIST_COUNT = gql`
  query filteredListCount(
    $roleFilters: RoleFilterInput
    $isActive: Boolean
    $withNoUsers: Boolean
    $useOrLogic: Boolean
  ) {
    filteredListCount(
      roleFilters: $roleFilters
      isActive: $isActive
      withNoUsers: $withNoUsers
      useOrLogic: $useOrLogic
    )
  }
`;
